import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'

const Button = styled.button`
  border-radius: 10px;
  border: 1px dashed var(--gray);
  color: var(--gray);
  background: var(--light-gray);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 300;
  padding: 1.5rem;
  transition: all 0.2s;
  flex-direction: column;
  width: 100%;
  flex: 1;
  margin: 1.25rem 0;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    color: var(--dark-gray);
  }
`

const Icon = styled.div`
  font-size: 2rem;
  margin-bottom: 1rem;
`

export default class OutlineButton extends Component {
  render() {
    const { icon, str, ...props } = this.props

    return (
      <Button {...props}>
        <Icon className={icon} />
        <Text str={str} />
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OutlineButton.js